// review requirements
export const reviewInitialState = {
  reloadReviewList: false,
};

export const reviewReducer = (state, action) => {
  switch (action.type) {
    case "SET_RELOAD_REVIEW_LIST":
      return { ...state, reloadReviewList: action.payload };
    default:
      return state;
  }
};
